import { render, staticRenderFns } from "./ServiceRequest.vue?vue&type=template&id=5b3f2696"
import script from "./ServiceRequest.vue?vue&type=script&lang=js"
export * from "./ServiceRequest.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequest.vue?vue&type=style&index=0&id=5b3f2696&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports